import React, { useState, useEffect } from "react";
import BasicCustomTable from "../../../../component/basicTable";
import CustomPopupForm from "../../../../component/customPopupModel";
import CustomButton from "../../../../component/elements/CustomButton/CustomButton";
import { useSelector } from "react-redux";
import axiosInstance from "../../../../configuration/request";
import { useSnackbar } from "../../../../component/SnackbarContext";
import {
  creatService,
  generateServicesData,
  getColumnsByServiceType,
  updateService,
} from "../../../../utils/servicesConfig";
import FilterPopover from "../../../../component/filterPopover";

const DIALOG_TYPES = {
  CREATE: "service-offered",
  DELETE: "delete",
};

const filters = [
  { value: "all", label: "All Services" },
  { value: "WASH_N_FOLD", label: "Wash & Fold" },
  { value: "DRYCLEANING", label: "Dry Cleaning" },
  { value: "TAILORING", label: "Tailoring" },
];

const ServiceConfiguration = () => {
  const showSnackbar = useSnackbar();
  const { loginDetails } = useSelector((state) => state.counter);
  const storeId = loginDetails.storeId || null;
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState("");
  const [mode, setMode] = useState("create");
  const [selectedRow, setSelectedRow] = useState(null);
  const [serviceData, setServiceData] = useState([]);
  const [selectedType, setSelectedType] = useState("all");
  const [columns, setColumns] = useState();


  useEffect(() => {
    fetchServices(selectedType);
  }, []);

  const fetchServices = (value) => {
        let url = `/customer/services-offered?storeId=${storeId}`;

      if (value && value !== "all") {
        url += `&serviceType=${value}`;
      }
      const currentColumns = getColumnsByServiceType(value);
      setColumns(currentColumns)
    axiosInstance
      .get(url)
      .then((res) => {
        const formattedUser = generateServicesData(res?.data);
        setServiceData(formattedUser);
      })
      .catch((err) => showSnackbar(err?.response?.data?.message, "error"));
  };

  

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
    setDialogType("");
  };

  const handleAddServices = () => {
    setMode("create");
    setDialogType(DIALOG_TYPES.CREATE);
    setOpenDialog(true);
  };

  const handleEdit = (row) => {
    setMode("edit");
    setSelectedRow(row);
    setDialogType(DIALOG_TYPES.CREATE);
    setOpenDialog(true);
  };

  const handleDelete = (row) => {
    setSelectedRow(row);
    setDialogType(DIALOG_TYPES.DELETE);
    setOpenDialog(true);
  };

  const handleDeleteConfirm = async (row) => {
    try {
      await axiosInstance.delete(
        `/customer/services-offered/delete/${row.unit_pound_id}?serviceType=${row.serviceType}`
      );
      fetchServices(selectedType);
      handleCloseDialog();
    } catch (error) {
      showSnackbar(error?.response?.data?.message || "Something went wrong!", "error");
    }
  };

  const handleSubmit = async (service) => {
    if (mode === "create") {
      try {
        await creatService(service, storeId);
        handleCloseDialog();
        fetchServices(selectedType);
      } catch (error) {
        showSnackbar( error?.response?.data?.message || "Something went wrong!", "error");
      }
    } else {
      try {
        await updateService(service, storeId);
        handleCloseDialog();
        fetchServices();
      } catch (error) {
        showSnackbar(error?.response?.data?.message || "Something went wrong!", "error");
      }
    }
  };

  return (
    <div className="pl-6 pr-4">
      <div className="flex justify-between items-center w-full mb-2 px-3">
        <div className="space-y-2">
          <h2 className="text-2xl font-semibold">Service Configuration</h2>
          <FilterPopover
            selectedType={selectedType}
            setSelectedType={setSelectedType}
            filterValues={filters}
            fetchServices={fetchServices}
          />
        </div>

        <CustomButton
          onClick={() => handleAddServices()}
          customeClass="gradient-button w-[140px] h-[45px] mr-1"
        >
          <span className="text-xl mr-[4px]">+</span>Add services
        </CustomButton>
      </div>
      <div className=" px-2 pt-1  h-[calc(100vh-180px)] ">
        <BasicCustomTable
          columns={columns}
          rows={serviceData}
          onEdit={handleEdit}
          onDelete={handleDelete}
          colorHeader={true}
          frontendPagination={true}
           pageLimit={10}
          customClassHeader={"table-header-cell-colored"}
          tableName="permission"
          maxHeightClass="max-h-[calc(100vh-260px)]"
        />
      </div>

      {dialogType === DIALOG_TYPES.CREATE && (
        <CustomPopupForm
          isOpen={openDialog}
          handleClose={handleCloseDialog}
          dialogType={DIALOG_TYPES.CREATE}
          mode={mode}
          dialogDetails={selectedRow}
          onSubmit={handleSubmit}
        />
      )}

      {dialogType === DIALOG_TYPES.DELETE && (
        <CustomPopupForm
          isOpen={openDialog}
          handleClose={handleCloseDialog}
          dialogType={DIALOG_TYPES.DELETE}
          onDelete={handleDeleteConfirm}
          dialogDetails={{
            title: "Delete Confirmation",
            content: "Are you sure you want to delete service record?",
            rowData: selectedRow,
          }}
          type={"setting"}
        />
      )}
    </div>
  );
};

export default ServiceConfiguration;
